import { UserType } from '@cnx-saas/common';

interface User {
  userId: string;
  email: string;
  tenantId: string;
  roles?: string[];
  userType: UserType;
}

interface Impersonator {
  id: string;
}

interface LocalAuthState {
  readonly user: User;
  readonly impersonator?: Impersonator;
  readonly token: string;
  readonly refreshToken: string;
  readonly timeSkew: number;
}

enum UserRoleLegacy {
  SHIPPER = 'SHIPPER',
  CARRIER = 'CARRIER',
  CNX = 'CNX',
}

interface LocalAuthStateLegacy {
  readonly username: string;
  readonly token: string;
  readonly role: UserRoleLegacy;
  readonly companyId?: number;
  readonly userId?: number;
  readonly impersonator?: string;
}

export type { LocalAuthState, User, LocalAuthStateLegacy };
export { UserRoleLegacy };
